<div class="table-title">
  <h1>{{ tableName }}</h1>
</div>
<div class="table-header" *ngIf="tableHeaders?.length">
  <div class="header-checkbox" (click)="onCheckAll()" *ngIf="showCheckbox">
    <input type="checkbox" [ngModel]="isChecked" />
  </div>
  <div
    class="table-header-cell"
    *ngFor="let column of tableHeaders"
    (click)="onSort(column.name)"
    [attr.data-test]="'table-header-' + column.name"
  >
    {{ column.label }}
    <cc-user-list-sorting-icon
      *ngIf="enableSorting"
      [isActive]="sortingColumn === column.name"
      [currentSortOrder]="currentSortOrder"
    ></cc-user-list-sorting-icon>
  </div>
  <div class="table-header-cell" *ngIf="showPermissionHeader" i18n>Permission</div>
</div>
